import React, { useEffect, useState } from "react";
import Gfooter from "./Gfooter";
import axios from "axios";

function Privacy() {
  const [Privacy, setPrivacy] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/get_privacy_policy_list"
        );
        console.log("Full API response:", response.data);
        console.log("Data array:", response.data.data);
        setPrivacy(response.data.data || []);
        
      } catch (error) {
        console.error("Error fetching privacy policies:", error);
      }
    };
    fetchData();
  }, []);

  return (
    <>
      <div className="privacy-top">
        {Privacy.filter((Data) => {
          console.log("Checking Data:", Data);
          return Data.policy_id === "4"; // make sure it matches string
        }).map((Data, index) => (
          <div className="box27 container" key={index}>
            <div dangerouslySetInnerHTML={{ __html: Data.policy_paragraph }} />
          </div>
        ))}
      </div>
      <Gfooter />
    </>
  );
}

export default Privacy;
